import { toggleEducationBar } from "app/actions/educationBarActions";
import { useDispatch } from "react-redux";
import type { EducationBarProps } from "../components/EducationBar/EducationBar";
import type { EducationArticle } from "../types";
import EducationBarFromWindowContainer from "./EducationBarFromWindowContainer";

type EducationBarContainerProps = Pick<EducationBarProps, "onClose"> & { stateId: string };

const EducationBarContainer = (props: EducationBarContainerProps) => {
    const dispatch = useDispatch();

    function handleGetStartedClick(article: EducationArticle) {
        dispatch(toggleEducationBar(true, article));
    }

    return (
        <EducationBarFromWindowContainer
            {...props}
            onGetStartedClick={handleGetStartedClick}
        />
    );
}

export default EducationBarContainer;
